import ImageCarousel from "../ImageCarousel";

export default function Results(){
    return (
        <ImageCarousel
                data={[
                  {
                    imageURL: "img/istaf-sepaktakraw-result-1.jpg",
                    title: "result 1",
                  },
                  {
                    imageURL: "img/istaf-sepaktakraw-result-2.jpg",
                    title: "result 2",
                  },
                  {
                    imageURL: "img/istaf-sepaktakraw-result-3.jpg",
                    title: "result 3",
                  },
                  {
                    imageURL: "img/istaf-sepaktakraw-result-4.jpg",
                    title: "result 4",
                  },
                  {
                    imageURL: "img/istaf-sepaktakraw-result-8.jpg",
                    title: "result 5",
                  },
                  {
                    imageURL: "img/istaf-sepaktakraw-result-7.jpg",
                    title: "result 6",
                  },
                  {
                    imageURL: "img/istaf-sepaktakraw-result-6.jpg",
                    title: "result 7",
                  },
                  {
                    imageURL: "img/istaf-sepaktakraw-result-5.jpg",
                    title: "result 8",
                  },
                  {
                    imageURL: "img/istaf-sepaktakraw-result-9.jpg",
                    title: "result 9",
                  },
                  {
                    imageURL: "img/istaf-sepaktakraw-result-10.jpg",
                    title: "result 10",
                  },
                ]}
              />
    )
}